import React, { useContext } from 'react';
import { AppTableContext } from '../AppTableContext';
import { WMSkeleton, WMSkeletonProps } from '@walkme/wm-ui';

export const withSkeleton = (options: WMSkeletonProps) => <P extends $TSFixMe>(Component: React.ComponentType<React.PropsWithChildren<P>>): typeof Component => props => {
    const { loading } = useContext(AppTableContext);

    return loading ? <WMSkeleton variant="text" animation="wave" {...options} /> : <Component {...props} />;
};
